<template>
  <div class="app-toaster">
    <component
      :is="message.component"
      v-for="message of messages"
      :key="message.id"
      :message="message"
    >
    </component>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import appToast from '@/components/app-toast'
import addBankToast from '@/components/toasts/add-bank'
import deleteBankToast from '@/components/toasts/delete-bank'
import deleteRealestateToast from '@/components/toasts/delete-realestate'
import riskResult from '@/components/toasts/risk-result'
import resendConfirmation from '@/components/toasts/resend-confirmation'
import passwordUpdated from '@/components/toasts/password-updated'
import confirmSubscription from '@/components/toasts/confirm-subscription'

export default {
  name: 'AppToaster',

  components: {
    'app-toast': appToast,
    'add-bank': addBankToast,
    'delete-bank': deleteBankToast,
    'delete-realestate': deleteRealestateToast,
    'risk-result': riskResult,
    'resend-confirmation': resendConfirmation,
    'password-updated': passwordUpdated,
    'confirm-subscription': confirmSubscription
  },

  props: {
    name: {
      type: String,
      default: 'default'
    }
  },

  computed: mapState('toasts', {
    messages({ messages }) {
      return messages.filter(({ toaster }) => toaster === this.name)
    }
  })
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.app-toaster {
  position: fixed;
  pointer-events: none;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 3rem;
}

.app-toast {
  margin-bottom: 2.5rem;
}
</style>
